module.exports = __webpack_public_path__ + "img/icon2-3.a6288708.svg";